import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { KitaBenefitListItemExtension } from './kita-benefit-list-item.extension';
import { KitaBenefitMetadataExtension } from './kita-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('kita')
    .add(BenefitMetadataExtensionInterface, new KitaBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new KitaBenefitListItemExtension())
    .build(),
);
